import React, { useState, useEffect, useCallback } from 'react';
import { Button } from 'antd';
import { requestOTP, resendOTP } from '../../store/actions/AuthActions';
import { useDispatch, useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';

const ResendCode = ({ email_id }) => {
  const { t } = useTranslation('auth');
  const dispatch = useDispatch();
  const [timer, setTimer] = useState(60);

  const login_token = useSelector(state => state.invite.login_token);
  const otpStatus = useSelector(state => state.auth.otp?.status);

  useEffect(() => {
    if (timer <= 0) return;

    const interval = setInterval(() => {
      setTimer(prev => prev - 1);
    }, 1000);

    return () => clearInterval(interval);
  }, [timer]);

  const handleResend = useCallback(() => {
    if (otpStatus === 'expired') {
      dispatch(requestOTP(email_id, login_token));
    } else {
      dispatch(resendOTP(email_id));
    }
    setTimer(60);
  }, [dispatch, email_id, login_token, otpStatus]);

  return (
    <div style={{ textAlign: 'center', marginTop: 8 }}>
      {timer > 0 ? (
        <span style={{ fontSize: 14 }}>
          {t('resend_code.wait_for')}{' '}
          <span style={{ fontWeight: 500 }}>{t('resend_code.seconds', { count: timer })}</span>{' '}
          {t('resend_code.to_resend')}
        </span>
      ) : (
        <Button
          type="primary"
          htmlType="submit"
          onClick={handleResend}
          style={{
            width: '40%',
            height: 40,
            display: 'block',
            margin: '20px auto 0',
            backgroundColor: 'white',
            boxShadow: 'none',
            fontSize: 16,
            color: '#1890FF',
          }}
        >
          {otpStatus === 'expired' ? t('resend_code.request_new') : t('resend_code.resend')}
        </Button>
      )}
    </div>
  );
};

export default ResendCode;
